import React, { memo } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import styles from "../styles/MenuTooltip";
const useStyles = createUseStyles(styles, 'MenuTooltip');
const MenuTooltip = /*#__PURE__*/memo(_ref => {
  let {
    className: classNameProp,
    name = '',
    top = 0,
    toolTipOffset = 0
  } = _ref;
  const classes = useStyles();
  const rootClassName = classnames(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("span", {
    className: rootClassName,
    id: "fmMenuTooltip",
    style: {
      transform: `translate3d(0, ${top - toolTipOffset}px, 0)`
    }
  }, name);
});
process.env.NODE_ENV !== "production" ? MenuTooltip.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  top: PropTypes.number
} : void 0;
export default MenuTooltip;